<!-- 图片库 -->
<template>
    <div>
        <Modal
            v-model="modalVisible"
            :mask-closable="false"
            :closable="false"
            width="1000"
            class="picture-library-modal"
        >
            <!-- 头部 -->
            <div class="pl-header">
                <div class="pl-header-title">选择文件</div>
                <div class="pl-header-info" @click="getImgInfo()">
                    <span class="pl-header-tip">最大可上传50M的文件</span>
                    <span class="pl-header-space">
                        {{ free_space.surplus }} / {{ free_space.total }}
                        <Icon type="md-refresh" size="16" class="refresh-icon" />
                    </span>
                </div>
            </div>

            <!-- 主体内容 -->
            <div class="pl-body">
                <!-- 左侧分组列表 -->
                <aside class="pl-sidebar">
                    <div class="pl-sidebar-header">
                        <Button
                            class="pl-add-folder-btn"
                            icon="md-add"
                            long
                            @click="goAdd"
                        >
                            添加分组
                        </Button>
                    </div>
                    <div class="pl-sidebar-content">
                        <!-- 全部 -->
                        <div
                            :class="['pl-group-item', { active: lot_item == -1 }]"
                            @click="goActiveLotAll"
                        >
                            <Icon
                                type="ios-folder"
                                :class="['pl-group-icon', { active: lot_item == -1 }]"
                            />
                            <span class="pl-group-name">全部</span>
                            <span v-if="lot_item == -1" class="pl-group-active-mark"></span>
                        </div>
                        <!-- 分组列表 -->
                        <div
                            v-for="(item, index) in lot_array"
                            :key="item.id"
                            :class="['pl-group-item', { active: lot_item == index }]"
                            @click="goActiveLot(item.id, index)"
                        >
                            <Icon
                                type="ios-folder"
                                :class="['pl-group-icon', { active: lot_item == index }]"
                            />
                            <span class="pl-group-name">{{ item.name }}</span>
                            <div class="pl-group-actions">
                                <Icon
                                    type="md-create"
                                    class="pl-action-icon"
                                    @click.stop="goEdit(item)"
                                />
                                <Icon
                                    type="md-trash"
                                    class="pl-action-icon danger"
                                    @click.stop="goDel(item.id)"
                                />
                            </div>
                            <span v-if="lot_item == index" class="pl-group-active-mark"></span>
                        </div>
                    </div>
                </aside>

                <!-- 右侧内容区 -->
                <main class="pl-main">
                    <!-- 空状态 -->
                    <div v-if="img_arr.length == 0" class="pl-empty">
                        <div class="pl-empty-content">
                            <Icon type="ios-images" size="64" class="pl-empty-icon" />
                            <p class="pl-empty-text">暂无图片，请先上传图片</p>
                            <Upload
                                multiple
                                ref="uploadEmpty"
                                :show-upload-list="false"
                                :format="['jpg', 'jpeg', 'png', 'gif', 'mp4', 'avi', 'mov']"
                                :max-size="51200"
                                :on-exceeded-size="exceededSize"
                                :on-format-error="handleFormatError"
                                :before-upload="beforeUpload"
                                :auto-upload="false"
                                action=""
                            >
                                <Button type="primary" icon="md-cloud-upload">
                                    立即上传
                                </Button>
                            </Upload>
                        </div>
                    </div>

                    <!-- 图片网格 -->
                    <div v-else class="pl-content">
                        <div class="pl-toolbar">
                            <Upload
                                multiple
                                ref="uploadList"
                                :show-upload-list="false"
                                :format="['jpg', 'jpeg', 'png', 'gif', 'mp4', 'avi', 'mov']"
                                :max-size="51200"
                                :on-exceeded-size="exceededSize"
                                :on-format-error="handleFormatError"
                                :before-upload="beforeUpload"
                                :auto-upload="false"
                                action=""
                            >
                                <Button icon="md-cloud-upload">上传文件</Button>
                            </Upload>
                            <span class="pl-selected-count" v-if="newimgsrc.length > 0">
                                已选择 {{ newimgsrc.length }} 个文件
                            </span>
                        </div>

                        <div class="pl-grid">
                            <div
                                v-for="item in img_arr"
                                :key="item.random_number"
                                :class="['pl-grid-item', { selected: isSelected(item) }]"
                                @click="goActiveImg(item)"
                            >
                                <div class="pl-media-wrapper">
                                    <video
                                        v-if="getOriginalName(item.original_name)"
                                        class="pl-media"
                                        :src="item.path || prefix + item.random_number"
                                    />
                                    <img
                                        v-else
                                        class="pl-media"
                                        :src="item.path || prefix + item.random_number"
                                    />
                                    <div class="pl-media-overlay">
                                        <Icon
                                            v-if="isSelected(item)"
                                            type="md-checkmark-circle"
                                            class="pl-selected-badge"
                                        />
                                        <div class="pl-media-actions">
                                            <Icon
                                                type="md-trash"
                                                class="pl-delete-btn"
                                                @click.stop="goDeleteImg(item)"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <p class="pl-filename">{{ item.original_name }}</p>
                            </div>
                        </div>

                        <div class="pl-pagination">
                            <Page
                                show-total
                                size="small"
                                :total="storePrams.total"
                                :current="storePrams.page"
                                :page-size="storePrams.limit"
                                @on-change="changeIndexPage"
                            />
                        </div>
                    </div>
                </main>
            </div>

            <!-- 底部操作栏 -->
            <div slot="footer" class="pl-footer">
                <Button @click="cancelModal">关闭</Button>
                <Button
                    type="primary"
                    :disabled="newimgsrc.length === 0"
                    :loading="isUploading"
                    @click="submitModal"
                >
                    确认选择 ({{ newimgsrc.length }})
                </Button>
            </div>
        </Modal>
        <!-- 新增/编辑 -->
        <Modal v-model="editModal" :z-index="3000">
            <p slot="header">
                <span class="modal-title">{{ modal_title }}</span>
            </p>
            <div class="modal-container">
                <span class="left-span">分组名称：</span>
                <Input
                    class="left-input"
                    v-model="form_data.name"
                    show-word-limit
                    maxlength="8"
                    placeholder="请输入分组名称"
                />
            </div>
            <div slot="footer">
                <Button @click="editModal = false">取消</Button>
                <Button class="modal-btn" @click="goCreateFolder">保存</Button>
            </div>
        </Modal>
        <!-- 删除 -->
        <Modal v-model="delModal" :z-index="3000">
            <p slot="header">
                <span class="modal-title">{{ modal_title }}</span>
            </p>
            <div class="modal-container">
                <span class="del-span">是否确认删除分组！</span>
            </div>
            <div slot="footer">
                <Button @click="delModal = false">取消</Button>
                <Button class="modal-btn" @click="goDelFolder">保存</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
import {
    libray_create_folder,
    libray_show_folder,
    libray_del_folder,
    libray_show_img_list,
    libray_img_info,
    libray_delete_img,
} from "@/api/oss";
import config from "@/config";
import { getCookies, setStorages, getStorages, removeStorages } from "@/utils/helper";
export default {
    // 控制大MODAL开关
    props: {
        switch_modal: {
            type: Boolean,
            default: false,
        },
        select: {
            type: Number,
            default: 0,
        },
        select_type: {
            type: String,
            default: "image",
        },
    },
    data() {
        return {
            modalVisible: false, // 内部 Modal 状态
            upload_data: { folder_id: "0" }, // 图片上传参数
            prefix: "", // 图片地址前缀
            free_space: {}, // 剩余空间
            lot_item: -1, // 分组列表激活参数
            headers: { "p-c-access-token": getCookies("p_c_access_token") },
            uploads: config.apiUrl + "/a/gallery/image/upload",
            form_data: {
                id: "",
                name: "",
            },
            modal_title: "",
            editModal: false,
            delModal: false,
            lot_array: [], // 显示目录
            img_arr: [], // 显示图片列表
            storePrams: {
                page: 1,
                limit: 20,
                folder_id: 0,
            },
            imagesrc: "", // 选中图片路径
            newimgsrc: [],
            waitUploads: [],
            isUploading: false,
            // 缓存 key
            cacheImgInfo: "pl_img_info",
            cacheFolder: "pl_folder_list",
            cacheImgList: "pl_img_list",
        };
    },
    watch: {
        switch_modal: {
            handler(val) {
                this.modalVisible = val;
                if (val) {
                    this.loadCache();
                }
            },
            immediate: true,
        },
    },
    methods: {
        // 加载缓存，有缓存用缓存，没有则请求接口
        loadCache() {
            const cachedInfo = getStorages(this.cacheImgInfo);
            const cachedFolder = getStorages(this.cacheFolder);
            const cachedImgList = getStorages(this.cacheImgList);

            if (cachedInfo) {
                this.free_space = cachedInfo;
                this.prefix = cachedInfo.domain;
            }
            if (cachedFolder) {
                this.lot_array = cachedFolder;
            }
            if (cachedImgList) {
                this.img_arr = cachedImgList.data;
                this.storePrams.total = cachedImgList.total;
            }

            if (!cachedInfo || !cachedFolder || !cachedImgList) {
                this.getImgInfo();
            }
        },
        // 判断是否已选中
        isSelected(item) {
            return this.newimgsrc.some(
                (it) => it.random_number === item.random_number
            );
        },
        getOriginalName(str) {
            const lastIndex = str.lastIndexOf(".");
            let text = "";
            if (lastIndex !== -1 && lastIndex < str.length - 1) {
                text = str.substring(lastIndex + 1);
            } else {
                text = "";
            }
            if (text == "mp4" || text == "avi" || text == "mov") {
                return true;
            } else {
                return false;
            }
        },
        // 获取当前用户剩余空间
        getImgInfo() {
            libray_img_info()
                .then((res) => {
                    this.free_space = res.data;
                    this.prefix = res.data.domain;
                    // 保存到缓存
                    setStorages(this.cacheImgInfo, res.data);
                    // 显示目录
                    this.getShowFolder();
                    // 显示图片列表
                    this.getShowImgList();
                })
                .catch((res) => {
                    this.$Message.error(res.msg);
                });
        },
        // 显示图片列表
        getShowImgList() {
            libray_show_img_list(this.storePrams)
                .then((res) => {
                    this.img_arr = res.data.data;
                    this.storePrams.total = res.data.total;
                    // 保存到缓存
                    setStorages(this.cacheImgList, res.data);
                })
                .catch((res) => {
                    this.$Message.error(res.msg);
                });
        },
        changeIndexPage(e) {
            this.storePrams.page = e;
            this.getShowImgList();
        },
        // 删除图片
        goDeleteImg(item) {
            libray_delete_img({ random: item.random_number })
                .then((res) => {
                    // 只刷新图片列表缓存
                    removeStorages(this.cacheImgList);
                    this.getShowImgList();
                })
                .catch((res) => {
                    this.$Message.error(res.msg);
                });
        },
        beforeUpload(file) {
            const newFile = new File([file], file.name, { type: file.type });
            this.waitUploads.push(newFile);
            // 使用 setTimeout 确保 isUploading 标志先被设置
            if (!this.isUploading) {
                this.isUploading = true;
                setTimeout(() => this.startUploadQueue(), 0);
            }
            return false;
        },
        async startUploadQueue() {
            this.$Message.loading({ content: "上传中...", duration: 0 });
            while (this.waitUploads.length > 0) {
                const file = this.waitUploads.shift();
                await this.uploadSingleFile(file);
            }
            this.$Message.destroy();
            this.$Message.success("上传成功");
            // 只刷新图片列表缓存
            removeStorages(this.cacheImgList);
            this.getShowImgList();
            this.isUploading = false;
        },
        uploadSingleFile(file) {
            return new Promise((resolve) => {
                const formData = new FormData();
                formData.append("file", file);
                if (this.upload_data) {
                    Object.keys(this.upload_data).forEach((k) => {
                        formData.append(k, this.upload_data[k]);
                    });
                }
                const xhr = new XMLHttpRequest();
                xhr.open("POST", this.uploads);
                if (this.headers) {
                    Object.keys(this.headers).forEach((k) => {
                        xhr.setRequestHeader(k, this.headers[k]);
                    });
                }
                xhr.onload = () => resolve();
                xhr.send(formData);
            });
        },
        handleFormatError() {
            this.$Message.warning("暂不支持上传此格式");
        },
        exceededSize() {
            this.$Message.warning("文件大小限制在50MB以内");
        },
        // 显示目录
        getShowFolder() {
            libray_show_folder()
                .then((res) => {
                    this.lot_array = res.data;
                    // 保存到缓存
                    setStorages(this.cacheFolder, res.data);
                })
                .catch((res) => {
                    this.$Message.error(res.msg);
                });
        },
        // 激活分组列表
        goActiveLot(id, index) {
            this.lot_item = index;
            this.upload_data.folder_id = id;
            // 显示图片列表
            this.storePrams.page = 1;
            this.storePrams.folder_id = id;
            this.getShowImgList();
        },
        // 激活分组列表 -- '全部'
        goActiveLotAll() {
            this.lot_item = -1;
            this.upload_data.folder_id = 0;
            // 显示图片列表
            this.storePrams.page = 1;
            this.storePrams.folder_id = 0;
            this.getShowImgList();
        },
        // 激活图片列表
        goActiveImg(e) {
            let num = this.newimgsrc.findIndex(
                (item) => item.random_number == e.random_number
            );
            if (num == -1) {
                //选中
                if (
                    this.select_type == "video" &&
                    !this.getOriginalName(e.original_name)
                ) {
                    this.$Message.error("请选择视频");
                    return;
                }
                if (
                    this.select_type == "image" &&
                    this.getOriginalName(e.original_name)
                ) {
                    this.$Message.error("请选择图片");
                    return;
                }
                if (this.select == 0) {
                    // 多选模式：可以一直添加
                    this.newimgsrc.push(e);
                } else {
                    // 单选模式：替换已选
                    this.newimgsrc = [e];
                }
            } else {
                // 取消选中
                this.newimgsrc.splice(num, 1);
            }
        },
        // 新增name
        goAdd() {
            this.modal_title = "添加分组";
            this.form_data.id = "";
            this.form_data.name = "";
            this.editModal = true;
        },
        // 编辑name
        goEdit(e) {
            this.modal_title = "分组管理";
            this.form_data.id = e.id;
            this.form_data.name = e.name;
            this.editModal = true;
        },
        // 删除name
        goDel(id) {
            this.modal_title = "删除分组";
            this.form_data.id = id;
            this.delModal = true;
        },
        // 新增/编辑弹框保存按钮
        goCreateFolder() {
            libray_create_folder(this.form_data)
                .then((res) => {
                    // 只刷新分组列表缓存
                    removeStorages(this.cacheFolder);
                    this.getShowFolder();
                    this.editModal = false;
                    this.$Message.success(res.msg);
                })
                .catch((res) => {
                    this.$Message.error(res.msg);
                });
        },
        // 删除弹框保存按钮
        goDelFolder() {
            libray_del_folder({ id: this.form_data.id })
                .then((res) => {
                    // 只刷新分组列表缓存
                    removeStorages(this.cacheFolder);
                    this.getShowFolder();
                    this.delModal = false;
                    this.$Message.success(res.msg);
                })
                .catch((res) => {
                    this.$Message.error(res.msg);
                });
        },
        // 取消按钮
        cancelModal() {
            this.modalVisible = false;
            this.$emit("update:switch_modal", false);
        },
        // 确认按钮
        submitModal() {
            this.modalVisible = false;
            this.$emit("update:switch_modal", false);
            var byValue = [];
            var byValueSrc = [];
            this.newimgsrc.forEach((item) => {
                byValue.push(this.prefix + item.random_number);
                byValueSrc.push(item.random_number);
            });
            // 向父组件传递了1个值
            if (this.newimgsrc.length >= 0) {
                this.$emit("change", byValue, byValueSrc);
            }
        },
    },
};
</script>
<style scoped>
/* ===== CSS 变量 ===== */
:root {
    --pl-primary: var(--primary-color, #2d8cf0);
    --pl-bg: #f5f7fa;
    --pl-white: #ffffff;
    --pl-border: #e4e7ed;
    --pl-border-light: #ebeef5;
    --pl-text: #303133;
    --pl-text-regular: #606266;
    --pl-text-secondary: #909399;
    --pl-text-placeholder: #c0c4cc;
    --pl-danger: #f56c6c;
    --pl-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    --pl-radius: 8px;
    --pl-radius-sm: 4px;
}

/* ===== 模态框整体 ===== */
::v-deep .ivu-modal {
    top: 50px;
}

::v-deep .ivu-modal-body {
    padding: 0!important;
}

::v-deep .ivu-modal-footer {
    border-top: 1px solid var(--pl-border-light);
    padding: 12px 20px;
    background: var(--pl-white);
}



/* ===== 头部 ===== */
.pl-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 20px;
    border-bottom: 1px solid var(--pl-border-light);
    background: var(--pl-white);
}

.pl-header-title {
    font-size: 16px;
    font-weight: 600;
    color: var(--pl-text);
}

.pl-header-info {
    display: flex;
    align-items: center;
    gap: 16px;
    cursor: pointer;
}

.pl-header-tip {
    font-size: 13px;
    color: var(--pl-text-secondary);
}

.pl-header-space {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 13px;
    color: var(--pl-text-regular);
    padding: 4px 12px;
    background: var(--pl-bg);
    border-radius: 20px;
    transition: background 0.2s;
}

.pl-header-space:hover {
    background: var(--pl-border-light);
}

.refresh-icon {
    transition: transform 0.3s;
}

.pl-header-space:hover .refresh-icon {
    transform: rotate(180deg);
}

/* ===== 主体布局 ===== */
.pl-body {
    display: flex;
    height: 480px;
    background: var(--pl-bg);
}

/* ===== 左侧边栏 ===== */
.pl-sidebar {
    width: 220px;
    flex-shrink: 0;
    background: #fafbfc;
    border-right: 1px solid var(--pl-border);
    display: flex;
    flex-direction: column;
}

.pl-sidebar-header {
    padding: 16px;
    background: var(--pl-white);
}

.pl-add-folder-btn {
    background: var(--pl-white) !important;
    border: 1px dashed var(--pl-primary) !important;
    color: var(--pl-primary) !important;
    font-weight: 500;
    height: 40px;
    transition: all 0.2s;
}

.pl-add-folder-btn:hover {
    background: rgba(45, 140, 240, 0.05) !important;
    border-style: solid !important;
}

.pl-add-folder-btn ::v-deep i {
    font-size: 18px;
    margin-right: 4px;
}

.pl-sidebar-divider {
    height: 8px;
    background: var(--pl-white);
    border-top: 1px solid var(--pl-border-light);
    border-bottom: 1px solid var(--pl-border-light);
}

.pl-sidebar-content {
    flex: 1;
    overflow-y: auto;
    padding: 0 8px 5px;
    background: #fafbfc;
}

.pl-sidebar-content::-webkit-scrollbar {
    width: 4px;
}

.pl-sidebar-content::-webkit-scrollbar-thumb {
    background: var(--pl-border);
    border-radius: 2px;
}

/* 分组项 */
.pl-group-item {
    display: flex;
    align-items: center;
    padding: 10px 12px;
    margin-bottom: 6px;
    border-radius: var(--pl-radius-sm);
    cursor: pointer;
    transition: all 0.2s;
    position: relative;
    background: var(--pl-white);
    border: 1px solid transparent;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
}

.pl-group-item:hover {
    border-color: var(--pl-border);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.06);
}

.pl-group-item.active {
    background: rgba(45, 140, 240, 0.08);
    border-color: var(--pl-primary);
    box-shadow: 0 0 0 1px rgba(45, 140, 240, 0.2);
}

.pl-group-icon {
    font-size: 18px;
    color: var(--pl-text-placeholder);
    margin-right: 8px;
    transition: color 0.2s;
}

.pl-group-icon.active {
    color: var(--pl-primary);
}

.pl-group-name {
    flex: 1;
    font-size: 14px;
    color: var(--pl-text-regular);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.pl-group-item.active .pl-group-name {
    color: var(--pl-primary);
    font-weight: 500;
}

.pl-group-actions {
    display: flex;
    gap: 8px;
    opacity: 0;
    transition: opacity 0.2s;
}

.pl-group-item:hover .pl-group-actions {
    opacity: 1;
}

.pl-action-icon {
    font-size: 16px;
    color: var(--pl-text-secondary);
    cursor: pointer;
    padding: 4px;
    border-radius: 4px;
    transition: all 0.2s;
}

.pl-action-icon:hover {
    background: var(--pl-border-light);
    color: var(--pl-primary);
}

.pl-action-icon.danger:hover {
    color: var(--pl-danger);
}

.pl-group-active-mark {
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 3px;
    height: 16px;
    background: var(--pl-primary);
    border-radius: 0 2px 2px 0;
}

/* ===== 主内容区 ===== */
.pl-main {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    background: var(--pl-white);
    margin: 12px;
    border-radius: var(--pl-radius);
    border: 1px solid var(--pl-border-light);
}

/* 空状态 */
.pl-empty {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
}

.pl-empty-content {
    text-align: center;
}

.pl-empty-icon {
    color: var(--pl-text-placeholder);
    margin-bottom: 16px;
}

.pl-empty-text {
    font-size: 14px;
    color: var(--pl-text-secondary);
    margin-bottom: 20px;
}

/* 内容区 */
.pl-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: 20px 20px 0;
    overflow: hidden;
}

.pl-toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
    flex-shrink: 0;
}

.pl-selected-count {
    font-size: 13px;
    color: var(--pl-primary);
    background: rgba(45, 140, 240, 0.1);
    padding: 4px 12px;
    border-radius: 20px;
}

/* 图片网格 */
.pl-grid {
    flex: 1;
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
    gap: 16px;
    overflow-y: auto;
    padding-right: 8px;
}

.pl-grid::-webkit-scrollbar {
    width: 6px;
}

.pl-grid::-webkit-scrollbar-thumb {
    background: var(--pl-border);
    border-radius: 3px;
}

.pl-grid-item {
    cursor: pointer;
    border-radius: var(--pl-radius-sm);
    overflow: hidden;
    transition: all 0.2s;
}

.pl-grid-item:hover {
    box-shadow: var(--pl-shadow);
}

.pl-grid-item.selected {
    box-shadow: 0 0 0 2px var(--pl-primary);
}

.pl-grid-item.selected .pl-media-wrapper {
    border: 4px solid rgba(45, 140, 240, 0.3);
}

.pl-media-wrapper {
    position: relative;
    aspect-ratio: 1;
    background: var(--pl-bg);
    overflow: hidden;
}

.pl-media {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.3s;
}

.pl-grid-item:hover .pl-media {
    transform: scale(1.05);
}

.pl-media-overlay {
    position: absolute;
    inset: 0;
    background: linear-gradient(to bottom, rgba(0,0,0,0) 50%, rgba(0,0,0,0.4) 100%);
    opacity: 0;
    transition: opacity 0.2s;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 8px;
}

.pl-grid-item:hover .pl-media-overlay,
.pl-grid-item.selected .pl-media-overlay {
    opacity: 1;
}

.pl-selected-badge {
    font-size: 24px;
    color: var(--pl-primary);
    align-self: flex-end;
}

.pl-media-actions {
    display: flex;
    justify-content: flex-end;
}

.pl-delete-btn {
    font-size: 20px;
    color: var(--pl-white);
    cursor: pointer;
    padding: 4px;
    border-radius: 50%;
    transition: all 0.2s;
}

.pl-delete-btn:hover {
    background: var(--pl-danger);
    transform: scale(1.1);
}

.pl-filename {
    font-size: 12px;
    color: var(--pl-text-regular);
    padding: 8px;
    margin: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    background: var(--pl-white);
}

/* 分页 */
.pl-pagination {
    display: flex;
    justify-content: flex-end;
    padding-top: 16px;
    margin-top: 16px;
    border-top: 1px solid var(--pl-border-light);
    flex-shrink: 0;
}

/* ===== 底部 ===== */
.pl-footer {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    align-items: center;
}

.pl-footer .ivu-btn {
    min-width: 88px;
}

.pl-footer .ivu-btn-primary:not([disabled]) {
    background: var(--pl-primary);
    border-color: var(--pl-primary);
    color: #000;
}

/* ===== 小模态框 ===== */
.modal-container {
    padding: 20px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
}

.left-span {
    flex-shrink: 0;
    font-size: 14px;
    color: var(--pl-text);
}

.left-input {
    width: 280px;
}

.del-span {
    font-size: 14px;
    color: var(--pl-text);
}

/* ===== 深度选择器 ===== */
::v-deep .ivu-modal-mask,
::v-deep .ivu-modal-wrap {
    z-index: 2222 !important;
}
</style>